"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DateParserFuzzy = require("./DateParserFuzzy");

var _DateParserFuzzy2 = _interopRequireDefault(_DateParserFuzzy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rangeRegx = /(.*)\s*(?:to\s|-)\s*(.*)/;

exports.default = function (s, opts) {
    var match = rangeRegx.exec(s),
        start,
        end;

    if (match === null) {
        // doesn't match the range specification, abort.
        return;
    }

    start = (0, _DateParserFuzzy2.default)(match[1], opts);
    end = (0, _DateParserFuzzy2.default)(match[2], opts);

    return {
        type: "range",
        start: start,
        end: end
    };
};
//# sourceMappingURL=DateParserRange.js.map